import _ from 'underscore';

angular.module('vastdesk').controller('DemandPartnerServerSideDemandTagTableController', ['$scope', function ($scope) {
  $scope.selectedDemandTagBulkActionIds = [];
  $scope.demandTagBulkActionDisabledConditions = {
    onlyProgrammaticGuaranteedSelected: false,
  };

  let allProgrammaticGuaranteedTagIds = [];

  const serverSideTable = $('#demand_partner_demand_tags_table');
  serverSideTable.on('xhr.dt', function(e, settings, json, xhr) {

    if (json && json.custom_data && json.custom_data.programmatic_guaranteed_tag_ids) {
      allProgrammaticGuaranteedTagIds = json.custom_data.programmatic_guaranteed_tag_ids;
    }
  });

  $scope.$watchCollection('selectedDemandTagBulkActionIds', function (new_val, old_val) {
    if (!Array.isArray(new_val)) {
      return;
    }

    $scope.demandTagBulkActionDisabledConditions.onlyProgrammaticGuaranteedSelected = _.difference(new_val, allProgrammaticGuaranteedTagIds).length === 0;
  });
}]);
